import { apiconst } from "../utils/app-const";
import httpService from "./httpService";
export const webDashboardService = {
    Get,
    Update,
    Delete,
    GetWorkingMode
};


async function Get() {
    return await httpService.get(apiconst.ENDPOINT + apiconst.VERSION + apiconst.WEBDASHBOARDSTORAGE, {});
}
async function Update(webDashboardStorageVM) {
    return await httpService.post(apiconst.ENDPOINT + apiconst.VERSION + apiconst.WEBDASHBOARDSTORAGE, webDashboardStorageVM);
}
async function Delete(id) {
    return await httpService.delete(apiconst.ENDPOINT + apiconst.VERSION + apiconst.WEBDASHBOARDSTORAGE + "/" + id, {});
}
async function GetWorkingMode(id) {
    return await httpService.get(apiconst.ENDPOINT + apiconst.VERSION + apiconst.WEBDASHBOARDSTORAGE+"/"+ apiconst.GETWORKINGMODE +"/" + id, {});
}